/**
 * Created by Denis Kuzin on 25 september 2025
 */

const PavilionOrdersWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        this.orders = new Orders(options);

        this._super({
            name: "OrdersWindow",
            closeButton: false,
            content: this.createContent(),
            noBackground: true
        });

        this.orders.on("orderClaimed", this.onOrderClaimed.bind(this), this);
        this.orders.on("orderStateChanged", this.onOrderStateChanged.bind(this), this);
        this.orders.on("scrollToSelected", this.scrollToSelectedOrder.bind(this), this);
        this.orders.on("ingredientsUpdated", this.updateInventory.bind(this), this);

        this.orders.scrollToSelectedOrderByMaker();
    },

    onShow: function () {
        this._super();

        if (cleverapps.tutorial.checkConditions({ tutorial: TutorialScenario.BASIC_TUTORIAL_NAME, manualClose: true })) {
            const recipe = this.orders.getCurrentMaker().recipe;
            const withAmount = (amount, icon) => new cleverapps.Layout([cleverapps.UI.generateOnlyText(String(amount), cleverapps.styles.FONTS.MINIMAL_DIALOGUE_HIGHLIGHT_TEXT), icon], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: 10
            });

            this.tradeDialogue = MergeTutorialHelper.createMinimalDialogue({
                text: "Merge3BaseTutorial.fable.trade",
                person: "dwarf",
                gravitate: MinimalDialogue.GRAVITATE.TOP
            }, [{
                templateItems: [[{
                    textWithIcon: "Merge3BaseTutorial.fable.trade",
                    getIcons: () => [
                        withAmount(recipe.ingredients[0].amount, Map2dLocation.currentLocation.harvested.getIngredientIcon(recipe.ingredients[0].ingredient)),
                        withAmount(recipe.order[0].amount, UnitView.getUnitImage(recipe.order[0].unit, { preferStatic: true }))
                    ],
                    highlight: true
                }]]
            }]);
        }
    },

    removeTradeDialogue: function () {
        if (this.tradeDialogue) {
            this.tradeDialogue.remove();
            this.tradeDialogue = undefined;
        }
    },

    createContent: function () {
        const fg = this.fg = new cleverapps.Spine(bundles.pavilionorderswindow.jsons.pavilion);
        fg.setAnimation(0, "animation", false);

        this.createMarqueeWithCurtains();
        this.createTitle();
        this.createCloseButton();
        this.createBackground();
        this.createScroll();
        this.createInventory();

        if (this.orderViews && this.orderViews.length === 0) {
            const placeholder = cleverapps.UI.generateOnlyText(Messages.get("OrdersWindow.placeholder"), cleverapps.styles.FONTS.LIGHT_TEXT);
            placeholder.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            placeholder.setDimensions(fg.width * 0.7, 0);
            placeholder.setAlignment(cleverapps.styles.PavilionOrdersWindow.placeholder);
            fg.addChild(placeholder);
        }

        return fg;
    },

    createMarqueeWithCurtains: function () {
        const slot = this.fg.getSlot("slot_marquee");
        const top = new cleverapps.Spine(bundles.pavilionorderswindow.jsons.marquee_with_curtains);

        top.setAnimation(0, "animation", false);
        top.setAlignment(slot.width / 2, slot.height / 2);

        slot.addChild(top);
    },

    createTitle: function () {
        const styles = cleverapps.styles.PavilionOrdersWindow.title;
        const slot = this.fg.getSlot("slot_title");

        const background = cleverapps.UI.createScale9Sprite(bundles.windows.frames.window_title_bg_png);
        background.setContentSize(styles);

        const text = cleverapps.UI.generateOnlyText(Messages.get("PavilionOrdersWindow.title"), cleverapps.styles.FONTS.WINDOW_TITLE_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.fitTo(background.width * 0.8);
        text.setAlignment(background.width / 2, background.height / 2 + styles.offset);

        background.addChild(text);

        slot.setLocalZOrder(1);
        slot.addChild(background);
    },

    createCloseButton: function () {
        const styles = cleverapps.styles.PavilionOrdersWindow.closeButton;
        const slot = this.fg.getSlot("slot_close");

        const closeButton = this.closeRoundButton = new CloseRoundButton({
            onClicked: this.close.bind(this),
            styles
        });
        closeButton.setVisible(!cleverapps.tutorial.checkConditions({ tutorial: TutorialScenario.BASIC_TUTORIAL_NAME, manualClose: true }));

        slot.setLocalZOrder(1);
        slot.addChild(closeButton);
    },

    createBackground: function () {
        const slot = this.fg.getSlot("slot_bg");

        const bg = this.bg = cleverapps.UI.createScale9Sprite(bundles.pavilionorderswindow.frames.back_wall);
        bg.setContentSize(slot.width, slot.height);
        bg.setAlignment(slot.width / 2, slot.height / 2);
        slot.setLocalZOrder(-1);

        slot.addChild(bg);
    },

    createScroll: function () {
        const slot = this.fg.getSlot("slot_scroll");
        const styles = cleverapps.styles.PavilionOrdersWindow.scroll;

        const orderViews = this.orderViews = Map2d.currentMap.customers.listCustomersWithRecipe()
            .map((customer) => new PavilionOrderView(customer, this.orders));

        const foregroundContent = new cleverapps.Layout(orderViews, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });

        const backgroundContent = new cc.Node();
        backgroundContent.setAnchorPoint(0.5, 0.5);
        backgroundContent.setContentSize(foregroundContent.getContentSize());

        orderViews.forEach((orderView) => {
            orderView.person.replaceParentSamePlace(backgroundContent);
        });

        const backgroundScroll = new cleverapps.UI.ScrollView(backgroundContent, {
            childrenVisibility: false,
            scrollBarEnabled: false,
            direction: cleverapps.UI.ScrollView.DIR_HORIZONTAL
        });
        backgroundScroll.setContentSize(slot.width, slot.height);
        backgroundScroll.touchScrollDisabled = true;

        const backgroundPosition = this.bg.convertToNodeSpace(slot.parent.convertToWorldSpace(slot.getPosition()));
        backgroundScroll.setPosition(backgroundPosition);
        this.bg.addChild(backgroundScroll);

        const foregroundScroll = this.foregroundScroll = new cleverapps.UI.ScrollView(foregroundContent, {
            childrenVisibility: false,
            scrollBarEnabled: false,
            direction: cleverapps.UI.ScrollView.DIR_HORIZONTAL
        });
        foregroundScroll.setContentSize(slot.width, slot.height);
        foregroundScroll.setAlignment(slot.width / 2, slot.height / 2);

        foregroundScroll.onUpdatePositionListener = this.createListener(() => {
            const foregroundPosition = foregroundScroll.getContainerPosition();
            backgroundScroll.innerContent.setPosition(-foregroundPosition.x, foregroundPosition.y);
        });

        slot.addChild(foregroundScroll);
    },

    createInventory: function () {
        const slot = this.fg.getSlot("slot_inventory");
        const styles = cleverapps.styles.PavilionOrdersWindow.inventory;

        const icons = Map2dLocation.currentLocation.harvested.listResources()
            .filter((ingredient) => ingredient.amount > 0)
            .map((ingredient) => new IngredientOrderIcon(ingredient, undefined, {
                iconScale: 1.35,
                iconPos: styles.iconPos
            }));
        const ingredients = this.ingredients = new cleverapps.Layout(icons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        ingredients.setAlignment(slot.width / 2, slot.height / 2);
        cleverapps.UI.fitToBox(ingredients, {
            width: slot.width,
            height: slot.height
        });

        ingredients.setName("ingredients");
        slot.addChild(ingredients);

        const title = cleverapps.UI.generateOnlyText(Messages.get("PavilionOrdersWindow.pantry"), cleverapps.styles.FONTS.PAVILION_PANTRY_TITLE_TEXT);
        title.setAlignment(styles.title);
        slot.addChild(title);

        const empty = this.emptyPantry = cleverapps.UI.generateOnlyText(Messages.get("PavilionOrdersWindow.pantry.empty"), cleverapps.styles.FONTS.LIGHT_TEXT);
        empty.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        empty.setDimensions(slot.width * 0.8, 0);
        empty.setAlignment(slot.width / 2, slot.height / 2);
        empty.setVisible(icons.length === 0);
        slot.addChild(empty);
    },

    showIngredientsDelta: function (maker) {
        const allIngredientsViews = this.ingredients.children;
        const ingredientsToSpend = maker.recipe.ingredients;

        ingredientsToSpend.forEach(({ ingredient, amount }) => {
            if (!ingredient) {
                return;
            }

            const currentIngredientView = allIngredientsViews.find((view) => view.ingredient && (view.ingredient.ingredient === ingredient));
            if (!currentIngredientView) {
                return;
            }

            cleverapps.aims.showDelta(-Math.min(currentIngredientView.ingredient.amount, amount), currentIngredientView, {});
        });
    },

    updateInventory: function (maker) {
        this.showIngredientsDelta(maker);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                const styles = cleverapps.styles.PavilionOrdersWindow.inventory;
                const icons = Map2dLocation.currentLocation.harvested.listResources()
                    .filter((ingredient) => ingredient.amount > 0)
                    .map((ingredient) => new IngredientOrderIcon(ingredient, undefined, {
                        iconScale: 1.35,
                        iconPos: styles.iconPos
                    }));

                this.ingredients.setItems(icons, true);
                this.emptyPantry.setVisible(icons.length === 0);
            })
        ));
    },

    onOrderStateChanged: function (maker) {
        if (maker && maker.getState() === Customer.STATE_READY && cleverapps.tutorial.checkConditions({ tutorial: TutorialScenario.BASIC_TUTORIAL_NAME, unit: maker.unit, manualClose: true })) {
            this.orders.processOrder(maker);
        }
    },

    onOrderClaimed: function (maker) {
        this.readyMaker = maker.unit;

        if (cleverapps.tutorial.checkConditions({ tutorial: TutorialScenario.BASIC_TUTORIAL_NAME, unit: maker.unit, manualClose: true })) {
            if (this.closeHint) {
                return;
            }

            this.orderViews.forEach((orderView) => orderView.adviceTarget.removeFromParent());
            this.removeTradeDialogue();
            this.closeRoundButton.setVisible(true);
            this.closeHint = FingerView.hintTap(this.closeRoundButton, { repeatDelay: 2 });

            this.closeDialogue = MergeTutorialHelper.createMinimalDialogue({
                text: "Merge3BaseTutorial.fable.close_tavern",
                person: "dwarf",
                gravitate: MinimalDialogue.GRAVITATE.BOTTOM
            });
            return;
        }

        this.close();
    },

    scrollToSelectedOrder: function (maker) {
        if (!this.foregroundScroll || !maker) {
            return;
        }

        const selectedOrder = this.orderViews.find((orderView) => orderView.maker === maker);

        if (selectedOrder) {
            this.foregroundScroll.scrollTo(selectedOrder, 0.8);
        } else {
            this.foregroundScroll.scrollToDefault();
        }
    },

    beforeCloseAnimation: function (callback) {
        FingerView.remove(this.closeHint);
        this.removeTradeDialogue();

        if (this.closeDialogue) {
            this.closeDialogue.remove();
            this.closeDialogue = undefined;
        }

        if (!this.readyMaker || cleverapps.tutorial.checkConditions({ tutorial: TutorialScenario.BASIC_TUTORIAL_NAME, unit: this.readyMaker, manualClose: true })) {
            callback();
            return;
        }

        const windowComponent = ComponentMap.get(this, WindowComponent);
        windowComponent.hideWindow();

        Map2d.currentMap.focusOnUnit(this.readyMaker, {
            allowScrollWithFocus: true,
            delay: 1,
            action: function () {
                this.readyMaker.handleClick();
            }.bind(this),
            callback
        });
    },

    listBundles: function () {
        return ["pavilionorderswindow", "orders_portraits"];
    }
});

const OrdersWindow = PavilionOrdersWindow;

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PAVILION_PANTRY_TITLE_TEXT: {
        size: 36,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.PavilionOrdersWindow = {
    title: {
        width: 440,
        height: 103,
        offset: 6
    },

    closeButton: {
        scale: [0.8, 1, 1],
        x: { align: "center" },
        y: { align: "center" }
    },

    scroll: {
        margin: -50,
        padding: {
            left: 100,
            right: 200
        }
    },

    inventory: {
        margin: 100,
        title: {
            x: { align: "center" },
            y: { align: "top", dy: 30 }
        },
        iconPos: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 15 }
        }
    },

    placeholder: {
        x: { align: "center" },
        y: { align: "center", dy: 145 }
    }
};